import { Api } from '@/api';
import { createContext } from 'react';

export interface OpenApiContextData {
    openApi: Api<unknown>;
}

export const OpenApiContext = createContext<OpenApiContextData | undefined>(
    undefined
);
